import { Box } from "@mui/material";
import styled from "styled-components";

export const ModalShell = styled(Box)`
    width: min(1120px, calc(100vw - 40px));
    height: min(88vh, 860px);
    min-height: 560px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    border-radius: 10px;
    background: #ffffff;
    box-shadow: 0 24px 64px rgba(16, 47, 67, 0.24);
    font-family: "Noto Sans";

    @media (max-width: 768px) {
        width: calc(100vw - 20px);
        height: calc(100vh - 20px);
        min-height: 0;
        border-radius: 8px;
    }
`;

export const ModalHeader = styled.div`
    min-height: 76px;
    padding: 18px 22px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    border-bottom: 1px solid #e5e9ec;
    box-sizing: border-box;
`;

export const HeaderIdentity = styled.div`
    min-width: 0;
    display: flex;
    align-items: center;
    gap: 12px;
`;

export const HeaderIcon = styled.div`
    width: 40px;
    height: 40px;
    display: grid;
    place-items: center;
    flex: 0 0 auto;
    border-radius: 8px;
    color: #0058a0;
    background: #eaf3f9;
`;

export const HeaderCopy = styled.div`
    min-width: 0;
`;

export const ModalTitle = styled.div`
    color: #0d0c0c;
    font-size: 20px;
    font-weight: 700;
    line-height: 27px;
`;

export const ModalSubtitle = styled.div`
    margin-top: 2px;
    color: #6d7478;
    font-size: 12px;
    line-height: 18px;
`;

export const ModalBody = styled.div`
    flex: 1 1 auto;
    min-height: 0;
    padding: 22px;
    overflow-y: auto;
    background: #fbfcfd;
`;

export const SetupPanel = styled.div`
    max-width: 920px;
    margin: 0 auto;
    padding: 22px;
    border: 1px solid #e1e6e9;
    border-radius: 8px;
    background: #ffffff;
`;

export const SectionHeading = styled.div`
    margin-bottom: 16px;
    color: #253238;
    font-size: 14px;
    font-weight: 700;
    line-height: 20px;
`;

export const DateGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
    margin-bottom: 20px;

    @media (max-width: 640px) {
        grid-template-columns: 1fr;
    }
`;

export const MaterialSection = styled.div`
    padding-top: 18px;
    border-top: 1px solid #edf0f2;
`;

export const FieldLabelRow = styled.div`
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
`;

export const FieldLabel = styled.div`
    color: #313a3e;
    font-size: 13px;
    font-weight: 600;
`;

export const SelectionCount = styled.div`
    color: #0058a0;
    font-size: 12px;
    font-weight: 600;
`;

export const Guidance = styled.div`
    margin-top: 12px;
    padding: 10px 12px;
    border-left: 3px solid #70a8cf;
    border-radius: 0 5px 5px 0;
    color: #5f696e;
    background: #f3f8fb;
    font-size: 12px;
    line-height: 18px;
`;

export const PreviewCanvas = styled.div`
    width: 100%;
    height: 100%;
    min-height: 0;
    padding: 14px;
    box-sizing: border-box;
    border: 1px solid #d8dfe3;
    border-radius: 7px;
`;

export const PreviewFrame = styled.iframe`
    width: 100%;
    height: 100%;
    display: block;
    border: 0;
    border-radius: 3px;
    background: #ffffff;
`;

export const ModalFooter = styled.div`
    min-height: 68px;
    padding: 14px 22px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    border-top: 1px solid #e5e9ec;
    background: #ffffff;
    box-sizing: border-box;

    @media (max-width: 640px) {
        align-items: stretch;
        flex-direction: column;
    }
`;

export const FooterHint = styled.div`
    color: #747d82;
    font-size: 12px;
    line-height: 18px;
`;

export const FooterActions = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 8px;

    @media (max-width: 640px) {
        & > button {
            flex: 1;
        }
    }
`;
